module.exports = __webpack_public_path__ + "static/media/dashboard.e7b8cddf.png";